import {
    DASHBOARD_PANEL_CREATE_EDIT_OPEN_MODAL,
    DASHBOARD_PANEL_CREATE_REQUEST,
    DASHBOARD_PANEL_CREATE_RESULT,
    DASHBOARD_PANEL_EDIT_REQUEST,
    DASHBOARD_PANEL_EDIT_RESULT,
    DASHBOARD_PANEL_SEARCH_REQUEST,
    DASHBOARD_PANEL_SEARCH_RESULT
} from 'Redux/actionTypes';

export const dashboardPanelCreateEditOpenModal = (open, data) => ({
    type: DASHBOARD_PANEL_CREATE_EDIT_OPEN_MODAL,
    payload: { open, data }
})

export const dashboardPanelCreateRequest = (data) => ({
    type: DASHBOARD_PANEL_CREATE_REQUEST,
    payload: data
})

export const dashboardPanelCreateResult = (data) => ({
    type: DASHBOARD_PANEL_CREATE_RESULT,
    payload: { data }
})

export const dashboardPanelEditRequest = (data) => ({
    type: DASHBOARD_PANEL_EDIT_REQUEST,
    payload: { data }
})

export const dashboardPanelEditResult = (data) => ({
    type: DASHBOARD_PANEL_EDIT_RESULT,
    payload: { data }
})

export const dashboardPanelSearchRequest = (data) => ({
    type: DASHBOARD_PANEL_SEARCH_REQUEST,
    payload: { data }
})

export const dashboardPanelSearchResult = (data) => ({
    type: DASHBOARD_PANEL_SEARCH_RESULT,
    payload: { data }
})